export default __webpack_public_path__ + "static/media/hotHome.55bc450c.JPG";